import React from 'react'
import PropTypes from 'prop-types'
import { BannerContainer, IconWrapper, Content, Title, Description, SkeletonBanner } from './styles'
import { Skeleton } from '../Skeleton'

const InfoBannerSkeleton = () => (
  <SkeletonBanner>
    <Skeleton width="24px" height="24px" borderRadius="50%" />
    <div style={{ flex: 1 }}>
      <Skeleton width="220px" height="16px" style={{ marginBottom: '8px' }} />
      <Skeleton width="100%" height="14px" style={{ marginBottom: '4px' }} />
      <Skeleton width="70%" height="14px" />
    </div>
  </SkeletonBanner>
)

export const InfoBanner = ({ show, isLoading }) => {
  if (isLoading) {
    return <InfoBannerSkeleton />
  }

  if (!show) {
    return null
  }

  return (
    <BannerContainer>
      <IconWrapper>
        <svg viewBox="0 0 20 20" fill="currentColor">
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
      <Content>
        <Title>Esta é a melhor condição disponível!</Title>
        <Description>
          Esta é a melhor condição para você negociar de forma rápida e digital. Nossos canais de atendimento{' '}
          <strong>não</strong> oferecem descontos diferentes.
        </Description>
      </Content>
    </BannerContainer>
  )
}

InfoBanner.propTypes = {
  show: PropTypes.bool,
  isLoading: PropTypes.bool
}

InfoBanner.defaultProps = {
  show: true,
  isLoading: false
}
